export const version = "bignumber/5.4.0";
//# sourceMappingURL=_version.js.map